const SITE_NAME = process.env.RAZZLE_SITE_NAME || 'Glamour'
const SITE_URL = process.env.RAZZLE_SITE_URL || 'https://www.glamour.co.za'

export const GooglePreferredSourceBadge = ({ imageSrc }) => {
  return (
    <div className='googlePreferredSourceBadge'>
      <a
        href={`https://google.com/preferences/source?q=${encodeURIComponent(SITE_URL)}`}
        rel='nofollow noreferrer'
        target='_blank'
      >
        <img
          alt={`Add ${SITE_NAME} as a preferred source on Google`}
          decoding='async'
          src={imageSrc}
        />
      </a>
    </div>
  )
}
